// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19UQG","controls":"styles_controls__qbugE","charLimit":"styles_charLimit__-a8U2","input":"styles_input__2lNtM","send":"styles_send__1F8oq"};